export const dark_grey_blue = '#2c3d52';
export const cool_grey = '#8e97a1';
export const greeny_blue = '#4cb58f';
export const dark_sky_blue = '#2ebbe1';
export const silver = '#ebecec';
export const customGreen = `#76b041`;
export const bluegreen = `#17bebb`;
export const ocean_blue = '#0074a6';
export const faded_red = '#dd4e60';
export const pale_grey = '#e9eaee';
export const silver_two = '#cbd0d2';
export const silver_three = '#e5e7e8';
export const silver_four = '#cbccd2';
export const pale_grey_two = '#fcfdfe';
export const dark_grey_blue_10 = 'rgba(44, 61, 82, 0.1)';
export const dark_grey_blue_20 = 'rgba(44, 61, 82, 0.2)';
export const dark_grey_blue_30 = 'rgba(44, 61, 82, 0.3)';
export const dark_grey_blue_70 = 'rgba(44, 61, 82, 0.7)';
export const dark_grey_blue_80 = 'rgba(44, 61, 82, 0.8)';
export const twilight = '#624589';
export const denim_blue = '#395994';
export const faded_grey = 'rgba(203, 208, 210, 0.5)';
export const primary_gradient = 'linear-gradient(257deg, #76c3b5, #3ea6ac 72%, #5296b3)';
export const faded_blue = '#E6F0F5';
export const highlight_green = '#EDF7F3';
export const highlight_blue = '#EAF8FC';
export const blue_white = '#fafcfd';
export const highlight_blue_2 = '#4d9cbe';
export const faded_blue_3 = "#E5F1F6";
export const faded_blue_2 = "#99C7DB";
export const green_1 = "#4EBE99";
export const text_blue = "#1e7eb9;"
export const pastel_light_blue = "#b3f1fe";
export const pastel_blue = "#cfe3fa";
export const pastel_green = "#89eac3";
export const pastel_purple = "#d8cff8";
export const pastel_gold = "#ffe9b1";
export const pastel_pink = "#ffbfd9";
export const pastel_yellow = "#fff656";
export const pastel_red = "#ffb3a7";
export const pastel_grey = "#e9eaee";
export const shade_2_lighter = '#f4f4f6';
export const page_primary_background = '#FAFCFD';
export const light_gray = '#f9f9f9';
export const dark_red = '#d8414d';
export const charcoal_blue = "rgba(50, 70, 97, 0.1)";
export const light_black = "rgba(0, 0, 0, 0.1)";

// new colors from style guide - replacing others above in the future

// defaults
export const color_defaults_black = "#000000";
export const color_defaults_white = "#FFFFFF";
export const color_defaults_spec = "#B42360";
export const color_defaults_specbg = "rgba(180, 35, 96, 0.1)";

// shades
export const color_shades_darkest = "#324661";
export const color_shades_darkest_transparent = "rgb(50,70,97,.85)";
export const color_shades_darker = "#8F97A1";
export const color_shades_dark = "#CBCCD2";
export const color_shades_medium = "#DCDDE2";
export const color_shades_light = "#E9EAEE";
export const color_shades_lighter = "#F4F4F6";
export const color_shades_lightest = "#FCFDFE";

// colors
export const color_colors_ocean = "#1E7EB9";
export const color_colors_light_ocean = "rgba(30, 126, 185, 0.08)";
export const color_colors_sky = "#36C4F2";
export const color_colors_royalty = "#6C4C9F";
export const color_colors_growth_background = "rgb(88,189,53,.1)";
export const color_colors_growth = "#58BD99";
export const color_colors_growth_light = "#E8F5E9";
export const color_colors_growth_border = "#A5D6A7";
export const color_colors_gold = "#F6A12F";
export const color_colors_gold_background = "rgb(246,161,47,.1)";
export const color_colors_decline = "#D8414D";
export const color_colors_light_blue = "#2BA4D8";

// color-variants
export const color_variants_shadow_10 = "rgba(50, 70, 97, 0.1)";
export const color_variants_shadow_20 = "rgba(50, 70, 97, 0.2)";
export const color_variants_ocean_light_1 = "rgba(30, 126, 185, 0.08)";
export const color_variants_ocean_light_2 = "rgba(30, 126, 185, 0.12)";
export const color_variants_ocean_xlight = "rgba(30, 126, 185, 0.04)";
export const color_variants_blue_2 = "rgba(30, 126, 185, 0.2)";
export const color_variants_green_2 = "rgba(88, 189, 153, 0.2)";
export const color_variants_red_2 = "rgba(216, 65, 77, 0.2)";
export const color_variants_gold_light = "rgb(246, 161, 47, 0.1)";
export const color_variants_gold_dark = "rgb(246, 161, 47, 1)";
export const color_variants_ocean_light_opaque = "#EDF5FA";
export const color_variants_ocean_light_opaque_2 = "#E4EFF6";
export const color_variants_royalty_light_10 = "#F0EDF5";
export const color_variants_royalty_light_20 = "#E2DBEC";
export const color_variants_main_bg = "#FAFCFD";
export const color_variants_decline_light_1 = "#FCECEE";

// gradients
export const color_gradients_blue_shift = "linear-gradient(90deg, #1E7EB9 0%, #36C4F2 100%, #2BA5D8 100%)";
export const color_gradients_green_shift = "linear-gradient(224.91deg, #76C3B5 3.06%, #3EA6AC 72.52%, #5296B3 100%)";
export const color_gradients_green_shift_reverse = "linear-gradient(14.4deg, #76C3B5 0%, #3EA6AC 71.66%, #5296B3 100%)";
export const color_gradients_silver_shift = "linear-gradient(224.91deg, #F5F9FC 3.06%, #FAFDFE 50.21%, #F4F5F5 100%)";
export const color_gradients_silver_shift_reverse = "linear-gradient(16.95deg, #F5F9FC 0%, #FAFDFE 48.69%, #F4F5F5 100.09%)";
export const color_gradients_knight_shift = "linear-gradient(224.91deg, #CBCCD2 3.06%, #A8A8A8 68.4%, #929292 100%)";

// highlights
export const color_highlights_green = "#89EAC3";
export const color_highlights_purple = "#D8CFF8";
export const color_highlights_pink = "#FFBFD9";
export const color_highlights_salmon = "#FFB3A7";
export const color_highlights_gold = "#FFE9B1";
export const color_highlights_yellow = "#FFF656";
export const color_highlights_cyan = "#B3F1FE";
export const color_highlights_blue = "#CFE3FA";

// text colors
export const color_text_default = color_shades_darkest;
export const color_text_light = color_shades_darker;
export const color_text_xlight = color_shades_dark;
export const color_text_link = color_colors_ocean;
export const color_text_inverse = color_defaults_white;

// Voicify Spark Colors
export const voicify_spark_lightest = "#f1f9fe";
export const voicify_spark_lighter = "#e2f3fc";
export const voicify_spark_light = "#bee7f9";
export const voicify_spark_medium = "#85d3f4"
export const voicify_spark_dark = "#44beec"
export const voicify_spark_darker = "#1ba5dc"
export const voicify_spark_darkest = "#0e85bb"

// ==================== CHART COLOR SYSTEM ====================
// Modern glass-like palette with blue hues for consistent dashboard styling
// Each color has a solid version (for borders/accents) and a glass version (for fills)

// Primary Chart Blues (from darkest to lightest)
export const chart_blue_1 = "#0a5f8a";          // Deep ocean
export const chart_blue_2 = "#0e85bb";          // Voicify Spark darkest
export const chart_blue_3 = "#1ba5dc";          // Voicify Spark darker
export const chart_blue_4 = "#2eb8e8";          // Bright cyan-blue
export const chart_blue_5 = "#44beec";          // Voicify Spark dark
export const chart_blue_6 = "#5ec8ef";          // Soft cyan
export const chart_blue_7 = "#78d2f3";          // Light cyan
export const chart_blue_8 = "#85d3f4";          // Voicify Spark medium
export const chart_blue_9 = "#a0dff7";          // Pale cyan
export const chart_blue_10 = "#bee7f9";         // Voicify Spark light
export const chart_blue_11 = "#d4f0fb";         // Very light cyan
export const chart_blue_12 = "#e2f3fc";         // Voicify Spark lighter

// Glass-effect fills (with transparency for modern look)
export const chart_glass_blue_1 = "rgba(10, 95, 138, 0.75)";    // Deep ocean glass
export const chart_glass_blue_2 = "rgba(14, 133, 187, 0.70)";   // Voicify Spark darkest glass
export const chart_glass_blue_3 = "rgba(27, 165, 220, 0.65)";   // Voicify Spark darker glass
export const chart_glass_blue_4 = "rgba(46, 184, 232, 0.60)";   // Bright cyan glass
export const chart_glass_blue_5 = "rgba(68, 190, 236, 0.55)";   // Voicify Spark dark glass
export const chart_glass_blue_6 = "rgba(94, 200, 239, 0.50)";   // Soft cyan glass
export const chart_glass_blue_7 = "rgba(120, 210, 243, 0.45)";  // Light cyan glass
export const chart_glass_blue_8 = "rgba(133, 211, 244, 0.40)";  // Voicify Spark medium glass
export const chart_glass_blue_9 = "rgba(160, 223, 247, 0.35)";  // Pale cyan glass
export const chart_glass_blue_10 = "rgba(190, 231, 249, 0.30)"; // Voicify Spark light glass
export const chart_glass_blue_11 = "rgba(212, 240, 251, 0.25)"; // Very light glass
export const chart_glass_blue_12 = "rgba(226, 243, 252, 0.20)"; // Lightest glass

// Complementary accent colors for variety (blue-adjacent hues)
export const chart_teal_1 = "#0f766e";          // Deep teal
export const chart_teal_2 = "#14b8a6";          // Bright teal
export const chart_teal_glass = "rgba(20, 184, 166, 0.55)";

export const chart_indigo_1 = "#4338ca";        // Deep indigo
export const chart_indigo_2 = "#6366f1";        // Bright indigo
export const chart_indigo_glass = "rgba(99, 102, 241, 0.55)";

export const chart_slate_1 = "#475569";         // Slate
export const chart_slate_2 = "#64748b";         // Light slate
export const chart_slate_glass = "rgba(100, 116, 139, 0.50)";

export const chart_sky_1 = "#0284c7";           // Sky blue
export const chart_sky_2 = "#38bdf8";           // Light sky
export const chart_sky_glass = "rgba(56, 189, 248, 0.55)";

// Chart sequential palette (for ordered data like bar charts)
// Returns 12 distinct blue shades from dark to light
export const chartSequentialBlues = [
    chart_blue_1,
    chart_blue_2,
    chart_blue_3,
    chart_blue_4,
    chart_blue_5,
    chart_blue_6,
    chart_blue_7,
    chart_blue_8,
    chart_blue_9,
    chart_blue_10,
    chart_blue_11,
    chart_blue_12
];

// Glass fills palette (matches sequential blues)
export const chartGlassBlues = [
    chart_glass_blue_1,
    chart_glass_blue_2,
    chart_glass_blue_3,
    chart_glass_blue_4,
    chart_glass_blue_5,
    chart_glass_blue_6,
    chart_glass_blue_7,
    chart_glass_blue_8,
    chart_glass_blue_9,
    chart_glass_blue_10,
    chart_glass_blue_11,
    chart_glass_blue_12
];

// Border colors (solid, for glass effect borders)
export const chartBorderBlues = [
    chart_blue_1,
    chart_blue_2,
    chart_blue_3,
    chart_blue_4,
    chart_blue_5,
    chart_blue_6,
    chart_blue_7,
    chart_blue_8,
    chart_blue_9,
    chart_blue_10,
    chart_blue_11,
    chart_blue_12
];

// Helper function style exports for dynamic color selection
export const getChartColor = (index: number): string => chartSequentialBlues[index % chartSequentialBlues.length];
export const getChartGlassColor = (index: number): string => chartGlassBlues[index % chartGlassBlues.length];
export const getChartBorderColor = (index: number): string => chartBorderBlues[index % chartBorderBlues.length];

// ==================== SEMANTIC CHART COLORS ====================
// Consistent colors for planned/contained vs unplanned/not-contained states

// Planned/Contained colors (blues)
export const chart_planned_fill = "rgba(14, 133, 187, 0.75)";
export const chart_planned_fill_light = "rgba(14, 133, 187, 0.15)";
export const chart_planned_fill_xlight = "rgba(14, 133, 187, 0.1)";
export const chart_planned_solid = "#0E85BB";

// Unplanned/Not-Contained colors (slate)
export const chart_unplanned_fill = "rgba(71, 85, 105, 0.75)";
export const chart_unplanned_fill_light = "rgba(71, 85, 105, 0.15)";
export const chart_unplanned_fill_xlight = "rgba(71, 85, 105, 0.1)";
export const chart_unplanned_solid = "#475569";

// ==================== UI COLORS ====================
// Button and interactive element colors

export const button_dark_bg = "#2C3D52";
export const button_dark_bg_hover = "#3a5068";
export const button_shadow_light = "0 2px 8px rgba(0, 0, 0, 0.15)";
export const text_dark = "#2D2D39";

// ==================== SHADOW COLORS ====================
// Box shadow definitions for consistent elevation

export const shadow_sm = "0 1px 3px rgba(0, 0, 0, 0.08)";
export const shadow_md = "0 4px 12px rgba(0, 0, 0, 0.12)";
export const shadow_md_alt = "0 4px 12px rgba(0, 0, 0, 0.15)";
export const shadow_lg = "0 6px 16px rgba(0, 0, 0, 0.18)";
export const shadow_xl = "0 8px 24px rgba(0, 0, 0, 0.15)";
export const shadow_modal = "0 4px 16px rgba(0, 0, 0, 0.12)";

// ==================== OVERLAY COLORS ====================
// Modal and overlay backgrounds

export const overlay_bg = "rgba(44, 61, 82, 0.7)";
export const overlay_border = "rgba(44, 61, 82, 0.8)";
export const overlay_white = "rgba(255, 255, 255, 0.85)";

// ==================== PREMIUM/GOLD COLORS ====================
// Premium feature styling

export const premium_gold = "#D4A017";
export const premium_gold_light = "#F4C430";
export const premium_gold_lightest = "#FFEAA7";
export const premium_gold_gradient = "linear-gradient(135deg, #E8B923 0%, #F4C430 50%, #FFEAA7 100%)";
export const premium_gold_shadow = "0 3px 12px rgba(244, 196, 48, 0.3)";
export const premium_gold_shadow_hover = "0 5px 16px rgba(244, 196, 48, 0.4)";

// ==================== STATUS COLORS ====================
// Status indicator colors for various states

export const status_success = "#16A34A";
export const status_success_bg = "rgba(34, 197, 94, 0.15)";
export const status_error = "#DC2626";
export const status_error_bg = "rgba(220, 38, 38, 0.15)";
export const status_error_bg_light = "rgba(220, 38, 38, 0.1)";
export const status_error_bg_xlight = "rgba(220, 38, 38, 0.05)";
export const status_neutral = "#6B7280";
export const status_neutral_bg = "rgba(107, 114, 128, 0.15)";



